import React from 'react';
import autobind from 'core-decorators/lib/autobind';
import PropTypes from 'prop-types';

import WixSDK from 'shared/utils/wix-sdk';

import classnames from 'classnames';
import { getNormalizedCachedDimensions } from 'widget/utils/normalize-image-dimensions';

import styles from './resized-image.styl';


export default class ResizedImage extends React.Component {

  static propTypes = {
    src: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    params: PropTypes.object,
    style: PropTypes.object,
    className: PropTypes.string,
    children: PropTypes.node,
    dataHook: PropTypes.string,
    withFallbackColor: PropTypes.bool,
    backgroundFit: PropTypes.bool,
    onImageLoaded: PropTypes.func,
    isDashboard: PropTypes.bool,
  };

  static defaultProps = {
    params: {},
    style: {},
    onImageLoaded: _.noop,
  };

  state = {
    resizedThumbnailUrl: null,
  };

  componentDidMount() {
    this.replaceResizedImage(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.replaceResizedImage(nextProps);
  }

  componentWillUnmount() {
    clearTimeout(this.preloadTimeout);
  }

  preloadImagePromise = Promise.resolve();
  lastLoadedImage = null;
  preloadTimeout = null;

  replaceResizedImage({ src, width, height, params, backgroundFit }) {
    const dimensions = getNormalizedCachedDimensions(src, {
      containerWidth: width,
      containerHeight: height,
    });
    let mode;
    if (backgroundFit) {
      mode = 'fit';
    }

    const url = WixSDK.Utils.Media.getResizedImageUrl(src, ...dimensions, params, mode);

    if (this.lastLoadedImage === url) {
      return;
    }

    this.lastLoadedImage = url;

    clearTimeout(this.preloadTimeout);

    // to avoid unnecessary requests, because of channel cover rendered initially,
    // and only after it removed we got video cover loading.
    this.preloadTimeout = setTimeout(() => {
      this.preloadImagePromise
        .then(() => new Promise(resolve => {
          if (!url) {
            resolve(null);
          }
          const image = new Image();
          image.onload = () => resolve(url);
          image.src = url;
        }))
        .then(loadedImageUrl => {
          if (!this.resizedImageRef) {
            return;
          }
          this.setState(
            {
              resizedThumbnailUrl: loadedImageUrl,
            },
            this.props.onImageLoaded
          );
        });
    });
  }

  @autobind
  handleRefUpdate(resizedImageRef) {
    this.resizedImageRef = resizedImageRef;
  }

  render() {
    const {
      className,
      width,
      height,
      style,
      children,
      dataHook,
      withFallbackColor,
      backgroundFit,
      isDashboard,
    } = this.props;

    const inlineStyle = {
      width: width && _.round(width),
      height: height && _.round(height),
      ...style,
    };

    const { resizedThumbnailUrl } = this.state;
    if (resizedThumbnailUrl) {
      inlineStyle.backgroundImage = `url(${resizedThumbnailUrl})`;
    }

    const classNames = classnames(className,
      styles['resized-image'], {
      [styles['with-fallback-color']]: withFallbackColor && !resizedThumbnailUrl,
      [styles['background-contain']]: backgroundFit,
      [styles.dashboard]: isDashboard,
    });

    return (
      <div className={classNames}
           style={inlineStyle}
           ref={this.handleRefUpdate}
           data-hook={dataHook}
           role="presentation">
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/resized-image/resized-image.js